import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Pencil } from 'lucide-vue-next';
    import { Button } from '@/components/ui/button';
    import {
        Dialog,
        DialogTrigger,
        DialogContent,
        DialogHeader,
        DialogTitle,
        DialogClose,
        DialogFooter,
        DialogBody,
    } from '@/components/ui/dialog';
    import { useI18n } from 'vue-i18n';
    import { useForm } from '@inertiajs/vue3';
    import { ref, computed } from 'vue';
    import VoucherAdministrateContent from './VoucherAdministrateContent.vue';
    import { VoucherAssignmentRule } from '@/types';
    import { usePage, router } from '@inertiajs/vue3';
    import { SharedData } from '@/types';
    import { useQueryClient } from '@tanstack/vue-query';
    import { toast } from 'vue-sonner';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VoucherAdministrate',
  setup(__props) {

    const selectedCompanyId = computed(
        () => usePage<SharedData>().props.auth.user.selected_company_id,
    );

    const { t } = useI18n();
    const queryClient = useQueryClient();

    const isOpen = ref(false);

    const form = useForm({
        cards: [],
        fallback_assignee_ids: [] as string[],
        fallback_employee_ids: [] as number[],
        fallback_user_ids: [] as number[],
        voucher_assignment_rules: [],
    });

    const updateAdministrate = () => {
        form.transform((data) => ({
            ...data,
            voucher_assignment_rules: data.voucher_assignment_rules?.filter(
                (fb: VoucherAssignmentRule) =>
                    !(
                        fb.prompt?.trim() === '' &&
                        (!fb.employee_ids || fb.employee_ids.length === 0) &&
                        (!fb.user_ids || fb.user_ids.length === 0)
                    ),
            ),
        }));
        form.post(
            route('v2.companies.voucher-assignment.update', { company: selectedCompanyId.value }),
            {
                preserveScroll: true,
                onSuccess: () => {
                    form.resetAndClearErrors();

                    isOpen.value = false;

                    queryClient.invalidateQueries({
                        queryKey: [QueryKey.COMPANY_VOUCHER_ASSIGNMENT, selectedCompanyId.value],
                    });

                    toast.success(t('vouchers.administrate.success'));
                },
                onError: (error: any) => {
                    toast.error(error?.error || t('vouchers.administrate.error'));
                },
            },
        );
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: isOpen.value,
    "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((isOpen).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: "ghost_warning",
            width: "narrow",
            class: "self-start",
            size: "xs"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('vouchers.administrate.title')) + " ", 1),
              _createVNode(_unref(Pencil), { class: "text-warning size-3" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DialogContent), { class: "sm:max-w-3xl" }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _withModifiers(updateAdministrate, ["prevent"]),
            class: "flex max-h-full flex-col overflow-hidden"
          }, [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('vouchers.administrate.title')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(DialogBody), { class: "space-y-5" }, {
              default: _withCtx(() => [
                _createVNode(VoucherAdministrateContent, { form: _unref(form) }, null, 8, ["form"])
              ]),
              _: 1
            }),
            _createVNode(_unref(DialogFooter), { class: "gap-2 border-t sm:justify-center" }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogClose), { "as-child": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      variant: "outline",
                      size: "sm",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('forms.cancel')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  disabled: _unref(form).processing,
                  loading: _unref(form).processing,
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('forms.save')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ]),
              _: 1
            })
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})